<script setup>
import { useI18n } from 'vue-i18n'
import { locales, setI18nLanguage } from '../i18n'

const { locale: i18nLocale } = useI18n()

const set = locale => {
  setI18nLanguage(i18nLocale, locale)
}
</script>

<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href="#"
      data-bs-toggle="dropdown"
    >
      <img
        :src="`./img/flag-${i18nLocale}.jpg`"
        alt="cz"
        height="14"
        width="21"
        class="me-1"
      >
      {{ locales[i18nLocale] }}
      <!-- m-0 to prevent popper warning: -->
      <ul class="dropdown-menu dropdown-menu-end m-0">
        <li
          v-for="locale in Object.keys(locales)"
          :key="locale"
          class="dropdown-item hstack gap-2"
          :class="i18nLocale === locale && 'active'"
          @click="set(locale)"
        >
          <img
            :src="`./img/flag-${locale}.jpg`"
            alt="cz"
            height="14"
            width="21"
          >
          {{ locales[locale] }}
        </li>
      </ul>
    </a>
  </li>
</template>
